import React, { useEffect, useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { post } from "../../Services/ApiHandler";
import { URL } from "../../Services/Constant";

const WasCompanySlotDays = ({
  option,
  days,
  setDays,
  handleSubmit,
  type,
  handleCheckboxChange,
  selectedDays,
  getDayList,
  getDateList,
  admin,
  setSelectedDays,
}) => {
  const [daysList, setDaysList] = useState(["T", "W", "Th", "F", "S", "SU"]);
  const [selectedDay, setSelectedDay] = useState(1);
  const [showSchedule, setShowSchedule] = useState(false);
  const [realDay, setRealDay] = useState("Monday");
  const [schedule, setSchedule] = useState([]);
  const [index_, setIndex_] = useState(0);

  const handleDayClick = (day, ind) => {
    setIndex_(ind);
    setSelectedDay(day);

    setSelectedDays(getMatchingDays(days[ind]));
  };

  const getMatchingDays = (currentDay) => {
    return days
      .filter(
        (d) =>
          d.type !== currentDay.type &&
          d.start_time === currentDay.start_time &&
          d.end_time === currentDay.end_time &&
          d.start_time &&
          d.end_time,
      )
      .map((d) => d.type);
  };

  // console.log('daysList', daysList)
  const handleToggle = (ind, type, value) => {
    let temp = [...days];
    if (type == "toggle") {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
        start_time: "",
        end_time: "",
      };
    } else {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
      };
    }
    setDays(temp);
  };

  // console.log('scheduleDays', schedule)
  //   console.log(selectedDay, "selectedDay");
  // console.log("days?.[index_]", days?.[index_]);

  const handleRemove = async (item) => {
    console.log("itemData", item);
    const payload = {
      type: item?.type,
      knf_company_site_id: option?.value,
    };
    console.log("payload", payload);
    let res = await post(URL.SPECIAL_DAY_DELETE, payload);
    if (res?.status == "success") {
      toast.success(res?.message);
      getDateList(option, index_);
      getDayList(option);
    } else {
      console.log("errRes", res);
    }
  };

  // console.log("option", option);

  const { pathname } = useLocation();
  const permission = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );

  const companyAddAllowed =
    (permission?.includes("CAN-Add-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-slot") ||
    (permission?.includes("CAN-Add-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-sites-view");

  const companyEditAllowed =
    (permission?.includes("CAN-Status-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-slot") ||
    (permission?.includes("CAN-Status-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-sites-view");

  const companyStatusAllowed =
    (permission?.includes("CAN-Status-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-slot") ||
    (permission?.includes("CAN-Status-KNF_COMPANY_ALERT_DAYS") &&
      pathname == "/company-sites-view");

  return (
    <div className="dashRightView">
      {option?.value && (
        <div
          className={`slot-container d-flex ${pathname == "/was-alert-days" ? "opacity-25" : ""}`}
        >
          {/* Days Button */}
          <div className="days-wrapper d-flex ac-jb">
            {days?.map((day, ind) => {
              return (
                <button
                  key={ind}
                  className={`f2 fs-sm-10 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 day-btn ${
                    selectedDay == day?.type ? "active" : ""
                  }`}
                  onClick={() => handleDayClick(day?.type, ind)}
                >
                  {day?.day}
                </button>
              );
            })}
          </div>

          {/* Schedule Box */}
          {days?.length > 0 && (
            <div className="Oversall-box flex-column ac-ja w-50">
              <div className="d-flex ac-js gap-3 my-4">
                <h3 className="f3 fs-sm-19 fs-md-18 fs-lg-18 fs-xl-22 fs-xxl-27">
                  {days?.[index_]?.day} Schedule
                </h3>
                <div
                  className="gap-3 d-flex toggle-btn"
                  onClick={() => {
                    const enabled =
                      days?.[index_]?.toggle && companyStatusAllowed;
                    if (type !== "slot") {
                      handleToggle(index_, "toggle", !enabled);
                      if (enabled) {
                        handleRemove(days?.[index_]);
                      }
                    }
                  }}
                  style={{ width: 89, height: 50, overflow: "hidden" }}
                >
                  {days?.[index_]?.toggle ? (
                    <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                  ) : (
                    <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                  )}
                </div>
                {/* <div
                className="gap-3 d-flex toggle-btn"
                onClick={() => {
                 
                }}
              >
                {days?.[index_]?.toggle ? (
                  <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                ) : (
                  <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                )}
              </div> */}
              </div>

              {days?.[index_]?.toggle && (
                <div className="schedule-box ">
                  <div className="d-flex flex-wrap gap-3">
                    {days
                      .filter((_, ind) => ind !== index_)
                      .map((i, ind) => (
                        <div key={ind}>
                          <input
                            type="checkbox"
                            style={{
                              accentColor: "#852e59",
                              height: "20px",
                              width: "20px",
                            }}
                            checked={selectedDays.includes(i.type)}
                            onChange={() => {
                              if (companyEditAllowed)
                                handleCheckboxChange?.(i.type);
                            }}
                          />

                          <p className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                            {i.day.slice(0, 3)}
                          </p>
                        </div>
                      ))}
                  </div>
                  <div className="time-inputs">
                    <div>
                      <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                        Start Time (mins)
                        <br />
                        Working Hrs
                      </label>
                      <input
                        type="time"
                        value={days?.[index_]?.start_time}
                        onChange={(e) => {
                          if (type !== "slot") {
                            handleToggle(index_, "start_time", e.target.value);
                          }
                        }}
                        disabled={pathname == "/alert-days"}
                      />
                    </div>
                    <div>
                      <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                        End Time (mins)
                        <br />
                        Working Hrs
                      </label>
                      <input
                        type="time"
                        value={days?.[index_]?.end_time}
                        onChange={(e) => {
                          if (type !== "slot") {
                            handleToggle(index_, "end_time", e.target.value);
                          }
                        }}
                        disabled={pathname == "/alert-days"}
                      />
                    </div>
                  </div>

                  {type !== "slot" && (
                    <>
                      {companyAddAllowed && (
                        <div className="d-flex as-je mt-5">
                          <button
                            className="submit-btn "
                            onClick={() => handleSubmit(index_)}
                          >
                            Submit
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WasCompanySlotDays;
